export default __webpack_public_path__ + "static/media/Abhinav.47c0f8f6.jpg";